import {ENUMS_URL} from '../../utils/endpoints';
import {requests} from '../../utils';
import {IEnums} from './enumsRedux';

export const EnumService = {
    getEnums: (): Promise<IEnums> => requests.get(ENUMS_URL),
}